
// @ts-nocheck


export const localeCodes =  [
  "en",
  "ua",
  "ru",
  "es",
  "pt",
  "zh"
]

export const localeLoaders = {
  en: [],
  ua: [],
  ru: [],
  es: [],
  pt: [],
  zh: []
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/c87bddb2" /* webpackChunkName: "config_i18n_46config_46ts_c87bddb2" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en",
      name: "English",
      files: []
    },
    {
      code: "ua",
      language: "uk",
      name: "Українська",
      files: []
    },
    {
      code: "ru",
      language: "ru",
      name: "Русский",
      files: []
    },
    {
      code: "es",
      name: "Español",
      files: []
    },
    {
      code: "pt",
      name: "Português",
      files: []
    },
    {
      code: "zh",
      name: "中文",
      files: []
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_and_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "https://0detect.com",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en",
    name: "English",
    files: []
  },
  {
    code: "ua",
    language: "uk",
    name: "Українська",
    files: []
  },
  {
    code: "ru",
    language: "ru",
    name: "Русский",
    files: []
  },
  {
    code: "es",
    name: "Español",
    files: []
  },
  {
    code: "pt",
    name: "Português",
    files: []
  },
  {
    code: "zh",
    name: "中文",
    files: []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/